import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { URL as FINANCE_URL, FINANCE_RESOURCES } from '../../helper';
import { GET_ACTION, DYNAMIC_SWITCHER_RESOURCES } from '../dynamicSwitcherHelper';
import UpdateConfig from './submodules/editConfig';

const PayoutDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.dynamicSwitcher}
				configResourceName={DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout}
				configActionName={GET_ACTION[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]}
				path={path}
				component={UpdateConfig}
				exact
			/>
			<Redirect to={FINANCE_URL[FINANCE_RESOURCES.dynamicSwitcher]} />
		</Switch>
	);
};

export default PayoutDashboard;
